export default __webpack_public_path__ + "static/footer-graphic-left-ed998417ce45cfe5deeaddde88d3fc21.png";